import { CheckCircle } from "@mui/icons-material";
import { capitalize } from "@mui/material";
import { useTranslation } from "react-i18next";

import { splitDateTime } from "../../services/DateTimeService";
import { MonitorService } from "../../types/monitor";

import styles from "./service-info-box.module.css";

interface Props {
  data?: MonitorService;
  typeOfService: string;
  color?: string;
  hideCheck?: boolean;
  lastServiceDate?: string;
  typeOfAppointment?: string;
  trapType?: string | null;
}
export const ServiceInfoBox = ({
  data,
  typeOfService,
  color,
  hideCheck = false,
  lastServiceDate,
  typeOfAppointment,
  trapType,
}: Props) => {
  const { t } = useTranslation();

  const { date } = splitDateTime(lastServiceDate);
  
  return (
    <div
      className={`${styles["services__info-box"]} ${
        styles[`info-box-${color}`]
      }`}
    >
      <div className={styles["services__info-box--column"]}>
        <div className={styles["services__info-box--container"]}>
          <p className={styles["services__info-box--text"]}>
            <b>
              {data?.monitorType} {data?.isTemporary ? "T" : ""}{data?.position}
            </b>
          </p>
          {trapType !== null && trapType !== undefined && (
            <p
              className={`${styles["services__info-box--tag"]} ${styles[`box-tag-${color}`]}`}
            >
              {t(trapType)}
            </p>
          )}
        </div>

        <p className={styles["services__info-box--text"]}>{data?.location}</p>
        <div className={styles["services__info-box--tags"]}>
          <p
            className={`${styles["services__info-box--tag"]} ${
              styles[`box-tag-${color}`]
            }`}
          >
            {t(typeOfService)}
          </p>

          {lastServiceDate && <p className={styles["date"]}>{date}</p>}

          {typeOfAppointment && (
            <p className={styles["card__info__type"]}>
              {typeOfAppointment === "auftrag"
                ? "Bekämpfung"
                : capitalize(typeOfAppointment)}
            </p>
          )}
        </div>
      </div>
      {!hideCheck && <CheckCircle />}
    </div>
  );
};
